import Cookies from 'js-cookie'

const TokenKey = 'X-YJ-Mobile-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  // 设置一个7天后过期的Cookie
  const expirationTime = new Date();
  expirationTime.setTime(expirationTime.getTime() + 7 * 24 * 60 * 60 * 1000);
  return Cookies.set(TokenKey, token, { expires: expirationTime })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function extractQueryParams(url) {
  let queryParams = {}
  if (url.includes('?')) {
    let queryString = url.substr(url.indexOf('?') + 1)
    let pairs = queryString.split('&')
    for (let pair of pairs) {
      let splitArray = pair.split('=')
      let key = splitArray[0]
      let value = splitArray[1]
      if (value.indexOf('#') > -1) {
        value = value.substring(0, value.indexOf('#'))
      }
      queryParams[key] = value
    }
  }
  return queryParams
}



// WEBPACK FOOTER //
// ./src/utils/auth.js